'use client'

import { User } from 'lucide-react'
import { MouseEventHandler } from 'react'
import { cn, signIn } from '@/lib/utils'
import { useSession } from '@/hooks/use-session'
import { useTranslations } from 'next-intl'
import { Button } from '@/app/[locale]/(ui)/button'

export const UserButton = ({
  badge = false,
  className,
  onClick,
}: {
  badge?: boolean
  className?: string
  onClick?: MouseEventHandler<HTMLButtonElement>
}) => {
  const { session } = useSession()
  const t = useTranslations()
  const firstName = session?.user?.firstName ?? ''
  const lastName = session?.user?.lastName ?? ''
  const lastLastName = lastName.trim().split(/\s+/).pop() ?? ''
  const fullName = session?.user ? `${firstName} ${lastName}` : ''
  const text = !session?.user
    ? t('Sign_in_business')
    : fullName.length > 20
      ? `${firstName} ${lastLastName.charAt(0)}.`
      : fullName

  const handleClick: MouseEventHandler<HTMLButtonElement> = (event) => {
    if (!session?.user) signIn('/bedrifter')
    onClick?.(event)
  }

  return (
    <Button variant="primary" className={cn('relative', className)} onClick={handleClick}>
      <User />
      <span>{text}</span>
      {badge && (
        <span className="absolute -right-4 -top-4 rounded-full border border-black bg-isekk p-2 py-1 text-sm leading-[1] text-black">
          {t('News')}
        </span>
      )}
    </Button>
  )
}
